import React, { useState, useMemo } from 'react';
import { Select } from 'antd';
import SelectIconWrapperAntd from '../../../../Components/SelectIconWrapperAntd';
import faceIcon from '../../../../Assets/Icons/ExitInterview/sentiment_satisfied.svg'; 
// Sentiment options
const SENTIMENT_OPTIONS = [
  { label: 'All', value: 'ALL',  },
  { label: 'Negative', value: 'NEGATIVE',  },
  { label: 'Neutral', value: 'NEUTRAL',  },
  { label: 'Positive', value: 'POSITIVE',  },
];

const SentimentalFilter = ({ setFilters, defaultValue = 'ALL', style = { width: 200 } }) => {
  const [value, setValue] = useState(defaultValue);

  const options = useMemo(
    () =>
      SENTIMENT_OPTIONS.map(o => ({
        value: o.value,
        label: (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {o.label}
          </span>
        ),
      })),
    [],
  );

  const handleChange = v => {
    setValue(v);
    setFilters?.(prev => ({ ...prev, sentimentBucket: v }));
  };

  // Find current color for start icon
  const current = SENTIMENT_OPTIONS.find(o => o.value === value);


  return (
    <SelectIconWrapperAntd startIcon={<img src={faceIcon} alt="Sentiment Icon" style={{ width: 16, height: 16 }} />}>
      <Select
        value={`Sentiment: ${value}`}
        options={options}
        style={style}
        onChange={handleChange}
        placeholder="Sentiment"
      />
    </SelectIconWrapperAntd>
  );
};

export default SentimentalFilter;